import request from "../../../helpers/request";

const tecnicoCmdService = {
  getCentralParam: async (data: any) => {
    const url = `${process.env.REACT_APP_API}/Cmd/GetCentralParam/${data}`;
    const response = await request({ url, method: "GET", data });
    return response.data;
  },

  findCentralCmd: async (idCentral: number) => {
    const response = await request({
      url: `${process.env.REACT_APP_API}/Cmd/FindCentralCmd/${idCentral}`,
      method: "GET",
    });
    return response.data;
  },

  cancelarCentralCmd: async (idCentral: number) => {
    const response = await request({
      url: `${process.env.REACT_APP_API}/Cmd/CancelarCentralCmd/${idCentral}`,
      method: "put",
    });
    return response.data;
  },

  postCmd: async (payload: {
    idCentral: number;
    cmdNumber: number;
    programacao?: string;
    firmwareFileName?: string;
    param?: any;
  }) => {
    const { idCentral, cmdNumber, programacao, firmwareFileName, param } =
      payload;

    const url = `${process.env.REACT_APP_API}/Cmd/PostCmd?idCentral=${idCentral}&cmdNumber=${cmdNumber}&programacao=${programacao || ""}&firmwareFileName=${firmwareFileName || ""}`;

    const response = await request({ url, method: "post", data: param || {} });
    return response.data;
  },
};

export default tecnicoCmdService;
